export default "__VITE_ASSET__WMjz96HO__"